import Tournament from '@/views/tournament/TournamentView.vue';

export const routes = [
  {name: 'home', path: '/:lang', component: Tournament},
  {path: '*', redirect: '/ru'},
];
